var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Fab, styled } from "@mui/material";
export const CustomSmallFab = styled(Fab)(({ theme }) => ({
    width: theme.spacing(4),
    height: theme.spacing(4),
    minWidth: theme.spacing(4),
    minHeight: theme.spacing(4),
}));
export const ExtraSmallFab = (_a) => {
    var { icon: IconComponent } = _a, props = __rest(_a, ["icon"]);
    return (_jsx(CustomSmallFab, Object.assign({ color: "primary" }, props, { children: _jsx(IconComponent, { style: { fontSize: "1.25rem" } }) })));
};
export const CustomToastFab = styled(Fab)(({ theme }) => ({
    width: theme.spacing(2.25),
    height: theme.spacing(2.25),
    minWidth: theme.spacing(2.25),
    minHeight: theme.spacing(2.25),
    marginRight: theme.spacing(1),
}));
export const CloseToastFab = (_a) => {
    var { icon: IconComponent } = _a, props = __rest(_a, ["icon"]);
    return (_jsx(CustomToastFab, Object.assign({}, props, { children: _jsx(IconComponent, { sx: { fontSize: "1rem" } }) })));
};
